module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/25ed681e2be779886d68064346029712.png";